import React, { FC, useMemo } from 'react';
import { Flex } from '@components/Flex';
import { registryPageData } from '@data-ts/pages/registry';
import { getRootUrl } from '@utils/urlHelpers.util';
import {
  PreviousSlideButton,
  NextSlideButton,
  StyledCTALink,
  StyledContainer,
  StyledTextPairing,
  StyledCarousel,
} from './RecommendedProducts.styles';
import { GridView, RecommendProducts, StoreFront } from '@sections/shared/GridView';
import { JoykitIcon } from '@components/JoykitIcon';

const { shopSection } = registryPageData;

interface RecommendedProductsProps {
  products: RecommendProducts;
}

export const RecommendedProducts: FC<RecommendedProductsProps> = ({ products }) => {
  const formattedProduct = useMemo(() => {
    const productData = [...products].filter(data => !!data.node.catalogItemGroupData.tileViewItem);
    productData.forEach(product => {
      product.node.catalogItemGroupData.tileViewItem.publicUrlPath =
        product.node.catalogItemGroupData.tileViewItem.brand.publicUrlPath || '';
    });
    return productData;
  }, [products]);
  return (
    <StyledContainer>
      <StyledCarousel
        wrapAround
        renderCenterLeftControls={({ previousSlide }) => (
          <PreviousSlideButton aria-label="Previous Slide Button" onClick={previousSlide} id="registry-shop-prev-btn">
            <JoykitIcon name="backChevron" color="mono1" size={24} />
          </PreviousSlideButton>
        )}
        renderCenterRightControls={({ nextSlide }) => (
          <NextSlideButton aria-label="Next Slide Button" onClick={nextSlide} id="regsitry-shop-next-btn">
            <JoykitIcon name="forwardChevron" color="mono1" size={24} />
          </NextSlideButton>
        )}
        renderBottomCenterControls={null}
      >
        <GridView
          items={formattedProduct?.slice(0, 6)}
          itemPerLine={{ sm: 3, belowSm: 2 }}
          eventName="RegistryProductClicked"
          storeFront={StoreFront.wedding}
          enabledAmplitude={true}
        />
        <GridView
          items={formattedProduct?.slice(6, 12)}
          itemPerLine={{ sm: 3, belowSm: 2 }}
          eventName="RegistryProductClicked"
          storeFront={StoreFront.wedding}
          enabledAmplitude={true}
        />
      </StyledCarousel>
      <Flex flexDirection="column" alignItems="center" paddingTop={6}>
        <StyledTextPairing
          titleVariant="calloutHed40"
          titleColor="neutra6"
          titleTagName="h3"
          title={shopSection.productSectionTitle}
          body={shopSection.productSectionSubTitle}
          bodyVariant="dek20"
          bodyColor="mono1"
          bodyMaxWidth="480px"
          marginBottom={[6, 9]}
          textAlign="center"
        />
        <Flex justifyContent="center" style={{ width: '100%' }}>
          <StyledCTALink id="shopProductsCTA" href={getRootUrl('/shop')} variant="primary" typography="featureHed17" hasChevron>
            {shopSection.productSectionCTA}
          </StyledCTALink>
        </Flex>
      </Flex>
    </StyledContainer>
  );
};
